export const QUERY_REFRESH_INTERVALS = {
  activeComments: 60_000,
  appVersion: 5 * 60_000,
  focusUserSync: 5 * 60_000,
  notificationsSync: 30_000,
  overviewInvalidation: 30_000,
  overview: 2 * 60_000,
} as const;

export const HEAVY_OVERVIEW_QUERY_OPTIONS = {
  staleTime: QUERY_REFRESH_INTERVALS.overview,
  refetchOnWindowFocus: false,
  refetchInterval: QUERY_REFRESH_INTERVALS.overview,
  refetchIntervalInBackground: false,
} as const;

export const OVERVIEW_QUERY_KEYS = [
  "dashboardData",
  "jobs",
  "producaoDesks",
  "desksNaoMidia",
  "reunioesNaoMidia",
  "campanhasPerformance",
  "jobsStakeholder",
  "desksRelacionamentoMidia",
] as const;
